import { Suspense, useContext } from 'react';
import { css } from '@emotion/react';
import * as Sentry from '@sentry/react';
import {
  CreateGroupChatContext,
  MAX_SELECTED_LENGTH,
  MaxSelectedArray,
} from '~/pages/CreateGroupChat';
import * as S from '~/pages/CreateGroupChat/index.styled';
import { SelectAiCard } from '~/components/CreateGroupChat';
import { DefaultButton, Divider, FlexStack } from '~/components/atomic';
import { Header } from '~/components/common/Header';
import { SetAICharacterSkeleton } from '~/components/common/Skeleton';
import { CharacterCard } from '../SelectAiCard/SelectAiCard.styled';
import ExploreCharacters from './ExploreCharacters';
import MyCharacters from './MyCharacters';
import MyFavoriteCharacters from './MyFavoriteCharacters';

export default function SetAiChatbot() {
  const {
    setStep,
    selectedAiCharacter,
    handleDeleteCharacterClick,
    handleSetAiClick,
  } = useContext(CreateGroupChatContext);

  const isMaxSelected = selectedAiCharacter.length >= MAX_SELECTED_LENGTH;

  return (
    <>
      <Header.Root>
        <Header.Section>
          <Header.PrevButton onPrevClick={() => setStep('GenerateGroupChat')} />
          <Header.Title>Set AI chatbot</Header.Title>
        </Header.Section>
      </Header.Root>

      <Suspense fallback={<SetAICharacterSkeleton />}>
        <S.Container>
          <S.Wrapper
            css={css`
              gap: 0;
            `}
          >
            <FlexStack>
              <S.SectionTitle>
                Selected {`(Up to ${MAX_SELECTED_LENGTH})`}
              </S.SectionTitle>
              {MaxSelectedArray.map((_, index) => {
                if (selectedAiCharacter[index]) {
                  const el = selectedAiCharacter[index];
                  return (
                    <SelectAiCard
                      key={el.character_id}
                      name={el.character_name}
                      description={el.character_desc}
                      like={el.liked_count}
                      isSelected={true}
                      createUsername={el.create_username}
                      imageUrl={el.character_image}
                      onClick={() => handleDeleteCharacterClick(el)}
                    />
                  );
                }

                return <CharacterCard key={index} />;
              })}
            </FlexStack>

            <Divider margin={16} />

            <Sentry.ErrorBoundary fallback={undefined}>
              <MyFavoriteCharacters isMaxSelected={isMaxSelected} />
            </Sentry.ErrorBoundary>

            <Divider margin={16} />

            <Sentry.ErrorBoundary fallback={undefined}>
              <MyCharacters isMaxSelected={isMaxSelected} />
            </Sentry.ErrorBoundary>

            <Divider margin={16} />

            <Sentry.ErrorBoundary fallback={undefined}>
              <ExploreCharacters isMaxSelected={isMaxSelected} />
            </Sentry.ErrorBoundary>
          </S.Wrapper>

          <S.DoneButtonWrapper>
            <DefaultButton
              disabled={selectedAiCharacter.length === 0}
              onClick={handleSetAiClick}
            >
              Done
            </DefaultButton>
          </S.DoneButtonWrapper>
        </S.Container>
      </Suspense>
    </>
  );
}
